import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {Dropdown} from "react-bootstrap";
import {useConfigurator} from "../context/ConfiguratorContext";
import {checkVisitor} from "../services/CommonService";

const languageList = [
    {value: "en", name: "English"},
    {value: "es", name: "Español"},
    {value: "fr", name: "Français"}
];

const Header = () => {
    const {mainCompanyData} = useConfigurator();

    const {i18n} = useTranslation();
    const [lanName, setLanName] = useState('English');

    useEffect(() => {
        const visitor = localStorage.getItem('solis_visitor');
        if (!visitor) {
            const fetchIpAndSend = async () => {
                try {
                    const res = await fetch("https://api.ipify.org?format=json");
                    const dataIp = await res.json();
                    const ip = dataIp.ip;

                    await checkVisitor({ip_address: ip});
                    localStorage.setItem('solis_visitor', ip);
                } catch (err) {
                    console.error("Failed to get IP or send:", err);
                }
            };

            fetchIpAndSend();
        }
    }, []);

    const changeLanguage = (e, data) => {
        e.preventDefault();
        setLanName(data.name);
        i18n.changeLanguage(data.value);
    };

    return (
        <div className="header-top px-3">
            <div className="container">
                <nav className="navbar navbar-light">
                    {mainCompanyData?.dealerData &&
                    (mainCompanyData.dealerData.dealer_company_logo || mainCompanyData.dealerData.dealer_company_name) ? (
                        mainCompanyData.dealerData.dealer_company_logo ? (
                            <div className="navbar-brand fw-bold logo-text">
                                <img
                                    src={mainCompanyData.dealerData.dealer_company_logo}
                                    alt={mainCompanyData.dealerData.dealer_company_name || "Dealer Logo"}
                                />
                            </div>
                        ) : (
                            <div className="navbar-brand fw-bold logo-text">
                                {mainCompanyData.dealerData.dealer_company_name}
                            </div>
                        )
                    ) : (
                        <Link to="/" className="navbar-brand fw-bold logo-text">
                            {mainCompanyData?.logo ? (
                                <img src={mainCompanyData.logo} alt={mainCompanyData?.name || "Company Logo"} />
                            ) : (
                                <>{mainCompanyData?.name}</>
                            )}
                        </Link>
                    )}

                    <div className="d-flex align-items-center gap-2">
                        <Dropdown>
                            <Dropdown.Toggle variant="none" id="dropdown-basic" className="no-caret border-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                     fill="none"
                                     stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                     className="me-2">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                                    <path d="M2 12h20"></path>
                                </svg>
                                {lanName}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {languageList.map((item, index) => (
                                    <Dropdown.Item key={index} onClick={(e) => changeLanguage(e, item)}
                                                   href="#!">{item.name}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </nav>
            </div>
        </div>
    );
};

export default Header;
